export class UserDefinitionSelectItem {
  name: string;
  values: string[];
}
